<template>
  <div class="label">
    <div class="label-content" style="background: transparent;">
      <RadioGroup v-model="groupType" type="button" style="margin-bottom:10px;">
        <Radio label="0" @click.native="staffList=allList;">全部</Radio>
        <Radio
          v-for="(item,index) in groupList"
          :key="index"
          :label="item.description"
        >{{item.description}}</Radio>
      </RadioGroup>
      <Table
        :border="false"
        row-key="id"
        :columns="columns"
        :data="staffList"
      
        no-data-text="暂无数据"
      >
        <template slot-scope="{ row, index }" slot="groupName">{{row.groupName}}</template>
        <template slot-scope="{ row, index }" slot="worker">{{row.worker}}</template>
        <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
        <template slot-scope="{ row, index }" slot="tel">{{row.tel}}</template>
        <template slot-scope="{ row, index }" slot="email">{{row.email}}

        </template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row, index }" slot="qRcode" >

                            <Upload
                                    ref="upload"
                                    :show-upload-list="false"
                                    :default-file-list="defaultList"
                                    :on-success="handleSuccess"
                                    :format="['jpg','jpeg','png']"
                                    :max-size="2048"
                                    :headers="formHeaders"
                                    :on-format-error="handleFormatError"
                                    :on-exceeded-size="handleMaxSize"
                                    :before-upload="handleBeforeUpload"
                                    multiple
                                    type="drag"
                                    :action="uploadUrl"
                                    style="display: inline-block;"


                            >
                              <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)" v-if="!row.qRcode" @click="getRow(row)">
                                <div style="font-size:25px">
                                  +
                                  <p style="font-size:14px">上传图片</p>
                                </div>
                              </div>
                              <img :src="row.qRcode" alt="" style="width: 100px;height:100px" v-if="row.qRcode" @click="getRow(row)">
                            </Upload>

          <iModal title="图片查看" cancel-text v-model="visible">
            <div style="text-align: center;">
              <img :src="imgName" v-if="visible" style="max-width: 100%" />
            </div>
          </iModal>



        </template>
        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
          <span style="display: inline-block;padding: 0 5px;">|</span>
          <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table>
      <!-- <Table
              :border="false"
              row-key="id"
              :columns="columns1"
              :data="staffList"
              v-else
              no-data-text="暂无数据"
      >
        <template slot-scope="{ row, index }" slot="groupName">{{row.groupName}}</template>
        <template slot-scope="{ row, index }" slot="worker">{{row.worker}}</template>
        <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
        <template slot-scope="{ row, index }" slot="tel">{{row.tel}}</template>
        <template slot-scope="{ row, index }" slot="email">{{row.email}}</template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>

        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
          <span style="display: inline-block;padding: 0 5px;">|</span>
          <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table> -->
    </div>
    <!-- 修改展商置顶 -->

    <staffAdd 
      :show="show"
      :groupList="groupList"
      @finish="init()"
      @close="show=false;"
    />

    <staffEdit
      v-if="editShowFlag"
      :show="editShowFlag"
      :groupList="groupList"
      :data="editInfo"
      @close="editShowFlag=false;editInfo={};"
      @finish="init()"
    />

  </div>
</template>

<script>
import staffAdd from "../components/staff-add.vue";
import staffEdit from "../components/staff-edit.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "host-set-staff",
  data() {
    return {
      columns: [
        {
          title: "类型",
          key: "groupName",
          align: "center",
        },
        {
          title: "负责项目",
          key: "worker",
          align: "center",
        },
        {
          title: "姓名",
          key: "name",
          align: "center",
        },
        {
          title: "Tel",
          key: "tel",
          align: "center",
        },
        {
          title: "Email",
          key: "email",
          align: "center",
        },
        {
          title: "显示顺序",
          key: "showIndex",
          align: "center",
          width: 100
        },
        // {
        //   title: "上传二维码",
        //   slot: "qRcode",
        //   align: "center",
        //   width: 150
        // },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      columns1: [
        {
          title: "类型",
          key: "groupName",
          align: "center",
        },
        {
          title: "负责项目",
          key: "worker",
          align: "center",
        },
        {
          title: "姓名",
          key: "name",
          align: "center",
        },
        {
          title: "Tel",
          key: "tel",
          align: "center",
        },
        {
          title: "Email",
          key: "email",
          align: "center",
        },
        {
          title: "显示顺序",
          key: "showIndex",
          align: "center",
          width: 100
        },

        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      groupType: "0",
      show: false,
      editShowFlag: false,
      editInfo: {},
      lable:'',
      staffList: [], // 客服
      groupList: [], // 客服类型
      defaultList:[],
      uploadList:[],
      imgurl:'',
      visible: false,
      imgName: "",
      uploadrow:{}
    };
  },
  components: {
    staffAdd,
    staffEdit
  },
  computed: {

    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  watch: {
    groupType(val, oldVal) {
      this.lable=val
      if (val) {
        this.groupList.map(c =>{
          if (c.description === val) {
            this.staffList = c.list;
          }
        })
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getContactUsByGroup:'hostCommonModule/getContactUsByGroup',
      getContactUs:'hostCommonModule/getContactUs',
      delContactUs:'hostCommonModule/delContactUs',
      editContactUs: "hostCommonModule/editContactUs"
    }),
    async init() {

      let groupList = await this.getContactUsByGroup();
      if (groupList && groupList.length > 0) {
        this.groupList = groupList;
      }
      console.log("groupList：",this.groupList);
      let staffList = await this.getContactUs();
      if (staffList && staffList.length > 0) {
        this.allList = staffList;
        this.staffList = staffList;
      }
      console.log("staffList",this.staffList);
      if (this.groupType) {
        this.groupList.map(c =>{
          if (c.description === this.groupType) {
            this.staffList = c.list;
          }
        })
      }
    },
    async delItem(item) { 
      let result = await this.delContactUs(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    showAdd() { // 新增
      this.show = true;
    },
    editShow(item) { // 编辑
      this.editShowFlag = true;
      this.editInfo = item;
    },

  }
};
</script>

<style scoped lang="scss">
.label {
  min-width: 1000px;
  min-height: 500px;
  padding: 30px;
}
</style>
